/**
 * @author Gananath Athukorala
 * @version 1.0
 * @since 31-8-2023
 */
import React, { useState, useEffect } from "react";
import api from "../../services/AuthApi";
import AsyncSelect from "react-select/async";

const SelectUserDropdown = ({ onChange }) => {
  const [data, setData] = useState([]);
  const [iserror, setIserror] = useState(false);

  let getAppConfig = {
    headers: {
      "Sort-Order": "ASC",
      Action: "VAU",
    },
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get("/users/0/10000/userId", getAppConfig);
        setData(
          res.data.dataList.map((user) => ({
            label: user.username,
            value: user.username,
          }))
        ); // assuming userId is the unique ID for each user
        setIserror(false);
      } catch (error) {
        console.log("Error loading data in dropdown", error);
        setIserror(true);
      }
    };

    fetchData();
  }, [iserror]);

  const filterUsers = (inputValue) => {
    return data.filter(({ label }) =>
      label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  const loadOptions = (inputValue, callback) => {
    setTimeout(() => {
      callback(filterUsers(inputValue));
    }, 1000);
  };

  return (
    <AsyncSelect
      cacheOptions
      loadOptions={loadOptions}
      defaultOptions={data}
      onChange={onChange}
    />
  );
};

export default SelectUserDropdown;
